// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3IxY8","emails":"CreateEditClinics_emails__30pKo","emailTagLabel":"CreateEditClinics_emailTagLabel__ssRx0"};